import React from "react";
import "./bigBar.css";
import { Bar } from "react-chartjs-2";
import Dropdown from "./dropdown";

const BigBar = ({ options, monthsConsumption, state, title, dropdown }) => {
  options = {
    responsive: true,

    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        ticks: { color: "#6C757D", font: { size: 12 } },
        beginAtZero: true,
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  monthsConsumption = [
    200, 300, 269, 400, 600, 420, 333, 245, 500, 300, 400, 600,
  ];

  state = {
    data: {
      labels: [
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
      ],
      datasets: [
        {
          //   label: "",
          backgroundColor: "#9ED3F4",
          borderColor: "#9ED3F4",
          borderWidth: 1,
          data: monthsConsumption,
          borderRadius: 12, // Round the top edges of bars
          barThickness: 24, // Width of the bars
        },
      ],
    },
  };

  return (
    <div className="bigBar">
      <div className="title">
        <span>{title}</span>
        {dropdown && <Dropdown data={dropdown} />}
      </div>
      <Bar height="210px" width="648px" options={options} data={state.data} />
    </div>
  );
};

export default BigBar;
